export const BASENAME = "/BAM";
export const BASE_URL = "/app/dashboard";
export const SETTINGS_URL = "/app/settings";
export const ACCESS_PEOPLE_URL = "/app/settings/acccess/people";
export const ACCESS_MANAGE_PROFILE_URL = "/app/settings/acccess/manage-profile";
export const ADS_MANAGER_URL = "/app/adsmanager";
export const BASE_TITLE = " | Media-Automation";
export const AWS_BUCKET_NAME = "media-feed-glocal-public";
const BASE_BACKEND_IP = "https://beta-bam.glocal360-dev.com/api";
const LOCAL_BASE_BACKEND_IP = "localhost:3005/api";

export const BASE_API_ENDPOINT = window.location.href.includes("localhost")
  ? `http://${LOCAL_BASE_BACKEND_IP}`
  : `${BASE_BACKEND_IP}`;


export const SUBDOMAIN = ".beta-bam.glocal360-dev.com";
export const ROOT_DOMAIN = ".glocal360-dev.com";
export const ROOT_URL = "https://glocal360-dev.com";
export const commonDealerEndPoint = "https://beta-api.glocal360-dev.com";
export const switchApiEndPoint = "https://beta-api.glocal360-dev.com/api/v1/common/user?domain=bam.glocal360-dev.com";
export const glocalLogoutUrl = "https://glocal360.auth.ap-south-1.amazoncognito.com/logout?client_id=3d9p8pggjk23tv8vofogi6urso&logout_uri=https://beta.glocal360-dev.com";
export const glocalRefreshTokenUrl = "https://beta-api.glocal360-dev.com/api/v1/auth/new-token";
export const platformIds = {  Facebook: "505095572697816",  Instagram: "17841472973661693"};
export const FETCH_DURATION = 10;
export const MAX_FETCH_DURATION = 60;
